module.exports = __webpack_public_path__ + "img/subject1_09.jpg";